import React from "react";
import { RCCIcon } from "react-common-components";
import Action from "../Action";
import { ActionProps } from "../Action/interface";



function Remove(props: ActionProps) {
	return (
		<Action
			{...props}
			isDelete
		>
			<RCCIcon 
				name="trash"
				size={10}
			/>
		</Action>
	);
}


export default Remove;
